export default {
    HEADER: 'Product category',
    PLACEHOLDER_NAME: 'Enter category name',
    LABEL_NAME: 'Category name',
    LABEL_STATUS: 'Status',
    LABEL_MULTI_SELECT: 'Multi select',
    LABEL_MAX_SELECTION: 'Max selection No',
    PLACEHOLDER_MAX_SELECTION: 'Allowed number',
    SAVE_BUTTON: 'Save',
    CANCEL_BUTTON: 'Cancel',
};
